<template>
  <div class="el-stripe">
    <!-- Manual Flow -->
    <ManualFlow
      v-if="showManualFlow"
      :title="$t('account.settings.manual-flow.title')"
      :callback="saveAntifraudSettings"
      :loading="accountLoading"
      :hideEditButton="!permissionIsEnabled('settings.manual_flow:edit')"
      @cancelEdit="resetObject(manualFlow, functionalitiesSettings.manualFlow)"
      :ref="refsName.manualFlow"
    >
      <template slot="content">
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.manual-flow.config') }}
                </h2>
              </div>
              <div class="el-chunk">
                <p class="emd-text _color_nonessential _size_small">
                  {{ $t('account.settings.manual-flow.config-detail') }}
                </p>
              </div>
            </div>
            <div class="emd-panel__block">
              <div class="emd-form-group">
                <label
                  class="emd-label"
                  for="enableManual"
                  >{{ $t('account.settings.manual-flow.status') }}</label
                >
                <span class="emd-input-helper"></span>
                <label
                  class="emd-switcher__label"
                  for="enableManual"
                >
                  <input
                    class="emd-switcher _color_success"
                    type="checkbox"
                    id="enableManual"
                    v-model="manualFlow.manual_flow"
                    @click="toogleAlertInfo(refsName.manualFlow)"
                  />
                  <div class="emd-switcher__area"></div>
                  <span class="emd-switcher__text">{{
                    $t('account.settings.manual-flow.active')
                  }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </template>
    </ManualFlow>

    <!-- Avisos -->
    <notifications
      v-if="showNotifications"
      :title="$t('account.settings.notifications.title')"
      :callback="saveNotificationsSettings"
      :loading="accountLoading"
      :formIsInvalid="$v.notifications.$invalid"
      :hideEditButton="!permissionIsEnabled('settings.notifications:edit')"
      @cancelEdit="
        resetObject(notifications, functionalitiesSettings.notifications)
      "
      :ref="refsName.notifications"
    >
      <template slot="content">
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.notifications.config') }}
                </h2>
              </div>
              <div class="el-chunk">
                <p class="emd-text _color_nonessential _size_small">
                  {{ $t('account.settings.notifications.config-detail') }}
                </p>
              </div>
            </div>
            <div class="emd-panel__block">
              <div class="emd-form-group">
                <label
                  class="emd-label"
                  for="enableNotifications"
                  >{{ $t('account.settings.notifications.status') }}</label
                >
                <span class="emd-input-helper"></span>
                <label
                  class="emd-switcher__label"
                  for="enableNotifications"
                >
                  <input
                    class="emd-switcher _color_success"
                    type="checkbox"
                    id="enableNotifications"
                    v-model="notifications.enabled"
                    @click="toogleAlertInfo(refsName.notifications)"
                  />
                  <div class="emd-switcher__area"></div>
                  <span class="emd-switcher__text">{{
                    $t('account.settings.notifications.active')
                  }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </template>
    </notifications>

    <!-- Cancelamento Garantido -->
    <guaranteed-cancellation
      v-if="permissionIsEnabled('settings.guaranteed_cancelation:view')"
      :title="$t('account.settings.cancellation.title')"
      :callback="saveCancellationSettings"
      :loading="accountLoading"
      :formIsInvalid="$v.cancellation.$invalid"
      :hideEditButton="
        !permissionIsEnabled('settings.guaranteed_cancelation:edit')
      "
      @cancelEdit="
        resetObject(cancellation, functionalitiesSettings.cancellation)
      "
      :ref="refsName.guaranteedCancellation"
    >
      <template slot="content">
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.cancellation.config') }}
                </h2>
              </div>
              <div class="el-chunk">
                <p class="emd-text _color_nonessential _size_small">
                  {{ $t('account.settings.cancellation.config-detail') }}
                </p>
              </div>
            </div>
            <div class="emd-panel__block">
              <!-- Status cancelamento garantido -->
              <div class="emd-form-group">
                <label class="emd-label">{{
                  $t('account.settings.cancellation.status')
                }}</label>
                <label
                  class="emd-switcher__label"
                  for="enabledGuaranteedCancelation"
                >
                  <input
                    class="emd-switcher _color_success"
                    type="checkbox"
                    id="enabledGuaranteedCancelation"
                    v-model="cancellation.enabled"
                    @click="toogleAlertInfo(refsName.guaranteedCancellation)"
                  />
                  <div class="emd-switcher__area"></div>
                  <span class="emd-switcher__text">{{
                    $t('account.settings.cancellation.active')
                  }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </template>
    </guaranteed-cancellation>

    <!-- Checkout -->
    <checkout
      v-if="showCheckout"
      :title="$t('account.settings.checkout.title')"
      :callback="saveCheckoutSettings"
      :loading="accountLoading"
      :formIsInvalid="$v.checkout.$invalid"
      :hideEditButton="!permissionIsEnabled('settings.checkout:edit')"
      @cancelEdit="resetObject(checkout, functionalitiesSettings.checkout)"
      :ref="refsName.checkout"
      :alertInfoFixed="checkout.checkout_enabled"
    >
      <template slot="content">
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.checkout.config') }}
                </h2>
              </div>
            </div>
            <div
              class="emd-panel__block"
              v-if="permissionIsEnabled('settings.checkout:edit')"
            >
              <div class="el-chunk">
                <div class="emd-form-group">
                  <label
                    class="emd-label"
                    for="status"
                    >{{ $t('account.settings.checkout.status') }}</label
                  >
                  <label
                    class="emd-switcher__label"
                    for="enableCheckout"
                  >
                    <input
                      class="emd-switcher _color_success"
                      type="checkbox"
                      id="enableCheckout"
                      v-model="checkout.checkout_enabled"
                      @click="fixedAlertInfo(refsName.checkout)"
                    />
                    <div class="emd-switcher__area"></div>
                    <span
                      class="emd-switcher__text"
                      v-if="checkout.checkout_enabled"
                      >{{ $t('account.settings.checkout.active') }}</span
                    >
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <p class="emd-text _color_nonessential _size_small">
                  {{ $t('account.settings.checkout.address-type-detail') }}
                </p>
              </div>
            </div>
            <div class="emd-panel__block">
              <div class="el-chunk">
                <div class="emd-form-group">
                  <label class="emd-label _required">{{
                    $t('account.settings.checkout.address-type')
                  }}</label>
                  <div
                    class="emd-select"
                    id="addressType"
                    v-bind:class="{
                      _state_error: $v.checkout.address_type.$invalid
                    }"
                  >
                    <select v-model="checkout.address_type">
                      <!-- <option :value="null"></option> -->
                      <option
                        v-for="(address, index) in addressTypes"
                        :value="index"
                        :key="index"
                      >
                        {{ $t(address) }}
                      </option>
                    </select>
                    <div class="emd-select__arrow"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <p class="emd-text _color_nonessential _size_small">
                  {{ $t('account.settings.checkout.enable-brands-detail') }}
                </p>
              </div>
            </div>
            <div class="emd-panel__block">
              <div class="el-chunk">
                <div class="emd-form-group">
                  <label
                    class="emd-label"
                    for="status"
                    >{{ $t('account.settings.checkout.enable-brands') }}</label
                  >
                  <label
                    class="emd-switcher__label"
                    for="enableBrands"
                  >
                    <input
                      class="emd-switcher _color_success"
                      type="checkbox"
                      id="enableBrands"
                      v-model="checkout.brands_enabled"
                    />
                    <div class="emd-switcher__area"></div>
                    <span class="emd-switcher__text">{{
                      $t('account.settings.checkout.active')
                    }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div
            class="emd-panel__section"
            v-if="checkout.brands_enabled"
          >
            <div class="emd-panel__block">
              <div class="el-chunk">
                <p class="emd-text _color_nonessential _size_small">
                  {{ $t('account.settings.checkout.enabled-brands-detail') }}
                </p>
              </div>
            </div>
            <div class="emd-panel__block">
              <div class="el-chunk">
                <div class="emd-form-group">
                  <jade-checkbox-group
                    :items="acceptedBrands"
                    :label="$t('account.settings.checkout.enabled-brands')"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <p class="emd-text _color_nonessential _size_small">
                  {{ $t('account.settings.checkout.required-fields-detail') }}
                </p>
              </div>
            </div>
            <div class="emd-panel__block">
              <div class="el-chunk">
                <div class="emd-form-group">
                  <jade-checkbox-group
                    :label="$t('account.settings.checkout.required-fields')"
                    :items="requiredFields"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </checkout>

    <!-- Apple pay -->
    <!-- <div class="el-section eu-fade-in">
      <div class="emd-container _highlight_header">
        <div class="emd-container__header">
          <h2 class="emd-text _size_section _color_default">{{$t('account.settings.apple-pay.title')}}</h2>
        </div>
        <div class="emd-container__content">
          <form>
            <fieldset>
              <div class="emd-panel">
                <div class="emd-panel__section">
                  <div class="emd-panel__block">
                    <div class="el-chunk">
                      <p class="emd-text _color_nonessential _size_small">{{$t('account.settings.apple-pay.config-detail')}}</p>
                    </div>
                  </div>
                  <div class="emd-panel__block">
                    <div class="el-chunk">
                      <button class="emd-btn _color_secondary" type="button" v-on:click="downloadFile('/files/certificado-producao.pdf')">
                        <i class="uil uil-import" transform="width-16" />
                        {{$t('account.settings.apple-pay.production-certificate')}}
                      </button>
                    </div>
                    <button class="emd-btn _color_secondary" type="button" v-on:click="downloadFile('/files/certificado-homologacao.pdf')">
                      <i class="uil uil-import" transform="width-16" />
                      {{$t('account.settings.apple-pay.certificate-of-approval')}}
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div> -->

    <!-- Split -->
    <split
      v-if="permissionIsEnabled('settings.split:view')"
      :title="$t('account.settings.split.title')"
      :callback="saveSplitSettings"
      :loading="accountLoading"
      :formIsInvalid="$v.split.$invalid"
      :hideEditButton="!permissionIsEnabled('settings.split:edit')"
      @cancelEdit="resetObject(split, functionalitiesSettings.split)"
      :ref="refsName.split"
    >
      <template slot="content">
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.split.config') }}
                </h2>
              </div>
              <div class="el-chunk">
                <p class="emd-text _color_nonessential _size_small">
                  {{ $t('account.settings.split.config-detail') }}
                </p>
              </div>
            </div>
            <div class="emd-panel__block">
              <!-- Status split -->
              <div class="el-chunk">
                <div class="emd-form-group">
                  <label
                    class="emd-label"
                    for="status"
                    >{{ $t('account.settings.split.status') }}</label
                  >
                  <span class="emd-input-helper"></span>
                  <label
                    class="emd-switcher__label"
                    for="enableSplit"
                  >
                    <input
                      class="emd-switcher _color_success"
                      type="checkbox"
                      id="enableSplit"
                      v-model="split.enabled"
                      @click="toogleAlertInfo(refsName.split)"
                    />
                    <div class="emd-switcher__area"></div>
                    <span class="emd-switcher__text">{{
                      $t('account.settings.split.active')
                    }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </split>
  </div>
</template>
<script>
import ConfigBox from '@/components/project/molecules/ConfigBox.vue'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from 'vuex'
import { JadeCheckboxGroup } from '@jade'
import {
  ACCEPTED_BRANDS_LIST,
  REQUIRED_FIELDS_LIST
} from './functionalities.list.js'
import { isSettingsManualFlowViewEnabled } from '../../actions-permission/settings-funcionalities.permission.js'

const FUNCTIONALITES_ENUM = {
  manualFlow: 'manualFlow',
  notifications: 'notifications',
  checkout: 'checkout',
  guaranteedCancellation: 'guaranteedCancellation',
  split: 'split'
}

export default {
  name: 'Functionalities',
  components: {
    Notifications: ConfigBox,
    GuaranteedCancellation: ConfigBox,
    Checkout: ConfigBox,
    Split: ConfigBox,
    ManualFlow: ConfigBox,
    JadeCheckboxGroup
  },
  data () {
    return {
      manualFlow: {},
      alertInfo: false,
      modalOpenned: false,
      filename: null,
      notifications: {},
      cancellation: {},
      checkout: {
        brands_enabled: false,
        address_type: null,
        accepted_brands: null,
        checkout_enabled: false
      },
      split: {},
      addressTypes: {
        brazilian: 'account.settings.checkout.brazilian',
        global: 'account.settings.checkout.global'
      },
      acceptedBrands: ACCEPTED_BRANDS_LIST,
      requiredFields: ''
    }
  },
  validations: {
    notifications: {
      enabled: {
        required
      }
    },
    cancellation: {
      enabled: {
        required: false
      }
    },
    checkout: {
      accepted_brands: {
        required: requiredIf(function () {
          return this.checkout.brands_enabled
        })
      },
      accepted_payment_methods: {
        required: false
      },
      address_type: {
        required
      },
      checkout_enabled: {
        required: false
      },
      optional_fields: {
        required: false
      },
      required_fields: {
        required: false
      }
    },
    split: {
      enabled: {
        required: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'functionalitiesSettings',
      'isEmployee',
      'businessModel',
      'hasPublicMerchantKey'
    ]),
    refsName () {
      return FUNCTIONALITES_ENUM
    },
    accountLoading () {
      return this.$store.getters.accountLoading
    },
    params: function () {
      return {
        merchantId: this.$store.getters.merchant.id,
        accountId: this.$store.getters.account.id
      }
    },
    showCheckout () {
      const permissionIsEnabled = this.permissionIsEnabled(
        'settings.checkout:view'
      )
      const hasEnable = this.functionalitiesSettings.checkout.checkout_enabled
      return (permissionIsEnabled && hasEnable) || this.isEmployee
    },
    showNotifications () {
      const permissionIsEnabled = this.permissionIsEnabled(
        'settings.notifications:view'
      )
      return permissionIsEnabled || this.isEmployee
    },
    showManualFlow () {
      return isSettingsManualFlowViewEnabled({
        permissionIsEnabledFn: this.permissionIsEnabled,
        isEmployee: this.isEmployee,
        businessModel: this.businessModel,
        hasPublicMerchantKey: this.hasPublicMerchantKey
      })
    }
  },
  methods: {
    ...mapActions(['UPDATE_ANTIFRAUD_SETTINGS']),
    saveAntifraudSettings: function (password) {
      const body = {
        password,
        manualFlow: this.manualFlow
      }
      return this.UPDATE_ANTIFRAUD_SETTINGS(body)
    },
    saveNotificationsSettings: function (password) {
      this.notifications.password = password
      return this.$store.dispatch(
        'UPDATE_NOTIFICATIONS_SETTINGS',
        this.notifications
      )
    },
    saveCancellationSettings: function (password) {
      this.cancellation.password = password
      return this.$store.dispatch(
        'UPDATE_CANCELLATION_SETTINGS',
        this.cancellation
      )
    },
    saveCheckoutSettings: function (password) {
      var body = this.checkout
      body.password = password
      if (!body.brands_enabled) {
        body.accepted_brands = []
      }
      if (
        body.required_fields.length &&
        !body.required_fields.includes('customer.name')
      ) {
        body.required_fields.push('customer.name')
      } else if (
        body.required_fields.length === 1 &&
        body.required_fields[0] === 'customer.name'
      ) {
        body.required_fields = []
      }
      return this.$store.dispatch('UPDATE_CHECKOUT_SETTINGS', body)
    },
    saveSplitSettings: function (password) {
      this.split.password = password
      return this.$store.dispatch('UPDATE_SPLIT_SETTINGS', this.split)
    },
    resetObject (obj, objFromApi) {
      obj = Object.assign(obj, objFromApi)
      if (Object.prototype.hasOwnProperty.call(obj, 'accepted_brands'))
        this.checkout.brands_enabled = this.checkout.accepted_brands.length > 0
    },
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    },
    toogleAlertInfo (refName) {
      this.$refs[refName].toogleInfoFunction()
    },
    fixedAlertInfo (refName) {
      this.$refs[refName].fixedInfoFunction()
    },
    updateCheckoutRequiredFields (newVal) {
      this.checkout.required_fields = newVal
        .filter(field => field.value)
        .map(field => field.key)
    },
    updateAcceptedBrands (newVal) {
      this.checkout.accepted_brands = newVal
        .filter(brand => brand.value)
        .map(brand => brand.key)
    }
  },
  created () {
    this.$store.dispatch('GET_ACCOUNT', this.params).then(res => {
      this.notifications = JSON.parse(
        JSON.stringify(this.functionalitiesSettings.notifications)
      )

      this.checkout = JSON.parse(
        JSON.stringify({
          ...this.checkout,
          ...this.functionalitiesSettings.checkout
        })
      )

      if (this.checkout.required_fields) {
        this.requiredFields = REQUIRED_FIELDS_LIST.map(item => {
          return {
            ...item,
            label: this.$t(item.label),
            value: this.checkout.required_fields.includes(item.key)
          }
        })
      }

      if (this.checkout.accepted_brands) {
        this.acceptedBrands.map(brand => {
          if (this.checkout.accepted_brands.includes(brand.key)) {
            brand.value = true
          }
        })
      }

      this.cancellation = JSON.parse(
        JSON.stringify(this.functionalitiesSettings.cancellation)
      )

      this.split = JSON.parse(
        JSON.stringify(this.functionalitiesSettings.split)
      )

      this.checkout.brands_enabled = this.checkout.accepted_brands.length > 0

      this.manualFlow = JSON.parse(
        JSON.stringify(this.functionalitiesSettings.manualFlow)
      )
    })

    this.requiredFields = REQUIRED_FIELDS_LIST.map(item => ({
      ...item,
      label: this.$t(item.label)
    }))
  },
  watch: {
    requiredFields: {
      handler (newVal) {
        this.updateCheckoutRequiredFields(newVal)
      },
      deep: true
    },
    acceptedBrands: {
      handler (newVal) {
        this.updateAcceptedBrands(newVal)
      },
      deep: true
    }
  }
}
</script>
